export enum CrudButtonType {
    Add = 1,
  Edit = 2,
  View = 3,
  Delete = 4,
  Refresh = 5,
  Export = 6,
  Chat = 9,
  Process = 10,
  Close = 11,
  CancelNow = 12,
  CancelNotice = 13,
  Approve = 14,
  Reject = 15,
  AddActivity = 16,
  GenerateReport = 17,
  DeviceAllocation = 18,
  Suspend = 19,
  Restore = 20,
  CancelLTE = 21,
  CancelApplication = 22,
  CancelReason = 23,
  ChangetoAerial = 24,
  RemoveRouter = 25,
  TrackAccount = 26
}
